export const getAllGreeksDummy = () => {
    return [
        "IV",
        "DELTA",
        "THETA",
        "VEGA",
        "GAMMA",
        "IV_VWAP",
        "VANNA",
        "CHARM",
        "SPEED",
        "ZOMMA",
        "COLOR",
        "VOLGA",
        "VETA",
        "TGR",
        "TV",
        "DTR",
    ];
};
export const getInitialGreeks = () => {
    return [{ id: "DELTA" }, { id: "VEGA" }, { id: "THETA" }];
};
